import { UDField } from '../../../users/UDField';
import { UDInput } from '../../../users/UDInput';

export interface DmTextFieldProps {
    label: string;
    value: string;
    onChange: (value: string) => void;
    error?: string;
    placeholder?: string;
    type?: string;
}

export function DmTextField({
    label,
    value,
    onChange,
    error,
    placeholder,
    type
}: DmTextFieldProps) {
    return (
        <UDField label={label}>
            <UDInput value={value} onChange={onChange} placeholder={placeholder} type={type} />
            {error && <span className="text-[11px] font-medium text-red-600">{error}</span>}
        </UDField>
    );
}
